var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-button"},[_c('q-btn',_vm._b({attrs:{"no-caps":""},on:{"click":function($event){return _vm.$emit('click')}}},'q-btn',{ ..._vm.$props, ..._vm.$attrs },false)),(_vm.$attrs.disable)?_c('q-tooltip',_vm._l((_vm.tooltips),function(tooltip){return _c('div',{key:tooltip},[_vm._v(_vm._s(tooltip))])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }